module.exports = __webpack_public_path__ + "img/snow-flake.7c1a4973.svg";